import React from 'react'
import PropTypes from 'prop-types'

/**
 * A configuration object that you pass to components that support virtual lists
 *
 * @typedef  {Object} VirtualList
 *
 * @param {(number|Function)} rowHeight        - height of rows within the virtual list (number or callback)
 * @param {number}            [scrollPosition] - scroll to a specific index in a virtual list
 * @param {number}            [rowOverscan]    - amount of rows to render outside of the view
 */
const virtualListPropType = PropTypes.shape({
    rowHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.func]).isRequired,
    rowOverscan: PropTypes.number,
    scrollPosition: PropTypes.number
})

export default virtualListPropType
